/**
 * description 原比例缩放图片瀑布流
 * created by he.zhikai
 * modified on 2018-03-29
 */
'use strict';
angular.module('util.waterflow', [])
    .directive('proportionImgflow', ['$timeout', function($timeout) {
        return {
            scope: {
                picturesData: '=', // 图片数据
                defaultHeight: '@', // 图片默认高度
                picWidth: '@', // 图片宽度字段
                picHeight: '@', // 图片高度字段
                multipleImgs: '=', // 是否显示多图
                childrenName: '@', // 子图片对象名
                notLastPage: '=' // 非最后一页
            },
            restrict: 'A',
            replace: false,
            transclude: false,
            link: function(scope, element, attrs, controller) {
                var multipleImgsWatcher; // 多图模式监听器
                init();
                picturesDataWatcher();

                /**
                 * [init description]初始化
                 * @return {[type]} [description]
                 */
                function init() {
                    // 如果是多图模式，则延迟加载（等待页面div宽度初始化完成）
                    if (!element.hasClass('proportion_imgflow')) {
                        $timeout(function() {
                            initStatus();
                            initData();
                        }, 1000);
                    } else {                
                        initStatus();
                        initData();
                    }
                    watchMultipleImgs();
                }

                /**
                 * [picturesDataWatcher description] 图片数量监听器
                 * @return {[type]} [description]
                 */
                function picturesDataWatcher() {
                    scope.$watch('picturesData', function(newV, oldV) {
                        if (newV.length !== oldV.length){
                            init();
                        }
                    });
                }

                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    scope.status = {
                        defaultHeight: angular.isDefined(scope.defaultHeight) ? parseInt(scope.defaultHeight) : 180, // 图片缩放高度
                        childrenEle: element[0].children, // 图片所在的div
                        picWidth: angular.isDefined(scope.picWidth) ? scope.picWidth : 'WIDTH',
                        picHeight: angular.isDefined(scope.picHeight) ? scope.picHeight : 'HEIGHT'
                    };
                    scope.data = {
                        autoWidth: '270', // 在获取不到图片的宽高时默认的宽度
                        autoHeight: '180' // 在获取不到图片的宽高时默认的高度
                    };
                }

                /**
                 * [initData description] 初始化数据
                 * @return {[type]} [description]
                 */
                function initData() {
                    // 如果没有图片数据或div未加载，则不继续执行
                    if (angular.isUndefined(scope.picturesData) || scope.picturesData.length === 0) {
                        return;
                    }
                    // 如果有图片数据但是页面元素还未生成，则延迟初始化
                    if (scope.picturesData.length > 0 && scope.status.childrenEle.length === 0) {
                        $timeout(function() {
                            initStatus();
                            initData();
                        }, 10);
                        return;
                    }
                    // 获取图片之间的外边距
                    scope.status.defaultMargin = parseInt(element.children('.imgflow_box').eq(0).css('margin-left')) + parseInt(element.children('.imgflow_box').eq(0).css('margin-right'));
                    // 容器宽度 加上外边距是为右侧与父div对齐
                    scope.status.containerWidth = element.width() + scope.status.defaultMargin;
                    var everyLineData = getEveryLineNums();
                    imgScaling(everyLineData);
                }

                /**
                 * [getEveryLineNums description] 计算每一行的图片数量
                 * @return {[type]} [description]
                 */
                function getEveryLineNums() {
                    var childrenEleLenght = scope.status.childrenEle.length, // 图片所在div数量
                        curWidth = 0, // 该行累计宽度
                        startCount = 0, // 开始图片索引
                        everyLine = []; // 每一行的图片分组
                    for (var i = 0; i < childrenEleLenght; i++) {
                        var imgAttr = getImgAttr(scope.picturesData[i]); // 图片属性（宽高）1
                        curWidth += scope.status.defaultHeight / imgAttr.height * imgAttr.width + scope.status.defaultMargin; // 计算缩放后的图片宽度
                        if (curWidth >= scope.status.containerWidth) {
                            var temp = {
                                startCount: startCount,
                                endCount: i, // 结束图片索引
                                height: Math.round(scope.status.containerWidth / curWidth * scope.status.defaultHeight) // 缩放图片高度，以匹配超出的图片宽度
                            };
                            everyLine.push(temp);
                            startCount = i + 1;
                            curWidth = 0;
                        }
                    }
                    return everyLine;
                }

                /**
                 * [getImgAttr description] 获取图片的尺寸等属性
                 * @param  {[type]} picData [description] 图片数据
                 * @return {[type]}         [description]
                 */
                function getImgAttr(picData) {
                    var width = Number(picData[scope.status.picWidth]) ? picData[scope.status.picWidth] : scope.data.autoWidth;
                    var height = Number(picData[scope.status.picHeight]) ? picData[scope.status.picHeight] : scope.data.autoHeight;
                    var imgAttr = {
                        width: width,
                        height: height
                    };
                    return imgAttr;
                }

                /**
                 * [imgScaling description] 图片精确缩放
                 * @param  {[type]} everyLineData [description] 分行后的图片数据
                 * @return {[type]}               [description]
                 */
                function imgScaling(everyLineData) {
                    // 先将lastLineHide属性置false
                    for (var m = 0; m < scope.picturesData.length; m++) {
                        scope.picturesData[m].lastLineHide = false;
                    }
                    var maxIndex = scope.status.childrenEle.length - 1;
                    if (everyLineData.length > 0) {
                        for (var i in everyLineData) {
                            setImgAttr(everyLineData[i].startCount, everyLineData[i].endCount, everyLineData[i].height, false);
                        }
                        if (everyLineData[i].endCount < maxIndex) {
                            // 如果不是末页，则最后一行（留白的那行）不显示
                            // if (angular.isDefined(scope.notLastPage) && scope.notLastPage === true) {
                            //     for (var j = everyLineData[i].endCount + 1; j < maxIndex + 1; j++) {
                            //         scope.picturesData[j].lastLineHide = true;
                            //     }
                            // } else {
                            setImgAttr(everyLineData[i].endCount + 1, maxIndex, scope.status.defaultHeight, true);
                            // }
                        }
                    } else {
                        // 如果不是末页，则最后一行（留白的那行）不显示
                        if (angular.isDefined(scope.notLastPage) && scope.notLastPage === true) {
                            for (var k = 0; k < maxIndex + 1; k++) {
                                scope.picturesData[k].lastLineHide = true;
                            }
                        } else {
                            setImgAttr(0, maxIndex, scope.status.defaultHeight, true);
                        }
                    }
                }

                /**
                 * [setImgAttr description] 设置图片的属性
                 * @param   {[type]}  startCount  [startCount description] 图片起始索引
                 * @param   {[type]}  endCount    [endCount description] 图片结束索引
                 * @param   {[type]}  height      [height description] 图片高度
                 * @param   {[type]}  lastOne     [lastOne description] 是否为最后一个
                 * @return  {[type]}              [return description]
                 */
                function setImgAttr(startCount, endCount, height, lastOne) {
                    var widthArray = getWidthArray(startCount, endCount, height, lastOne);
                    for (var i in widthArray) {
                        setDivAttr(widthArray[i], height, i);
                        setImageAttr(widthArray[i], height, i);
                    }
                    element.children('.imgflow_box').eq(startCount).css('margin-left', '0px');
                    if (!lastOne) {
                        element.children('.imgflow_box').eq(endCount).css('margin-right', '0px');
                    }
                }

                /**
                 * [getWidthArray description] 计算该行每个图片的宽度
                 * @param  {[type]} startCount [description] 图片起始索引
                 * @param  {[type]} endCount   [description] 图片结束索引
                 * @param  {[type]} height     [description] 图片高度
                 * @param  {[type]} lastOne    [description] 是否为最后一个
                 * @return {[type]}            [description]
                 */
                function getWidthArray(startCount, endCount, height, lastOne) {
                    var widthArray = [], // 图片宽度数组
                        curWidth = 0, // 图片累计宽度
                        imgNum = endCount > startCount ? endCount - startCount + 1 : 1; // 该行图片数量
                    for (var i = startCount; i <= endCount; i++) { // 计算每张图的宽度
                        var imgAttr = getImgAttr(scope.picturesData[i]);
                        widthArray[i] = height / imgAttr.height * imgAttr.width;
                        curWidth += widthArray[i];
                    }
                    // //将误差平均分
                    var deviation = !lastOne ? Math.round((scope.status.containerWidth - curWidth - scope.status.defaultMargin * imgNum) / imgNum) : 0;
                    curWidth = 0;
                    for (var j in widthArray) {
                        var totalWidth = Math.floor(widthArray[j] + deviation); // 算上误差的总宽度
                        if (curWidth + totalWidth + scope.status.defaultMargin > scope.status.containerWidth || (Number(j) === endCount && curWidth + totalWidth + scope.status.defaultMargin <= scope.status.containerWidth && !lastOne)) {
                            totalWidth = scope.status.containerWidth - curWidth - scope.status.defaultMargin;
                        }
                        widthArray[j] = (j == endCount) ? totalWidth - 1 : totalWidth;
                        curWidth += totalWidth + scope.status.defaultMargin;
                    }
                    return widthArray;
                }

                /**
                 * [setDivAttr description] 设置图片外层div宽高
                 * @param   {[type]}  width   [width description] 宽度
                 * @param   {[type]}  height  [height description] 高度 为文字预留空白，所以加47（2018.06.28：加第三行显示‘取签见撤’图标，所以再加23，即总共为70）
                 * @param   {[type]}  i       [i description] div索引
                 * @return  {[type]}          [return description]
                 */
                function setDivAttr(width, height, i) {
                    scope.status.childrenEle[i].style.width = width + 'px';
                    // 如果是多图模式，则高度不需要留空
                    scope.status.childrenEle[i].style.height = element.hasClass('proportion_imgflow') ? height + 70 + 'px' : height + 'px';
                }
                
                /**
                 * [setImageAttr description] 设置图片宽高
                 * @param   {[type]}  width   [width description] 宽度
                 * @param   {[type]}  height  [height description] 高度
                 * @param   {[type]}  i       [i description] 图片索引
                 * @return  {[type]}          [return description]
                 */
                function setImageAttr(width, height, i) {
                    var img = scope.status.childrenEle[i].getElementsByTagName('img')[0];
                    var baseSize = getImgAttr(scope.picturesData[i]);
                    // 若原图宽高比大于容器，则缩放原图宽度使其高度充满容器；反之亦然
                    if ((width / height) < (baseSize.width / baseSize.height)) {
                        width = baseSize.width / baseSize.height * height;
                    } else {
                        height = width / (baseSize.width / baseSize.height);
                    }
                    img.width = width;
                    img.height = height;
                }

                /**
                 * [watchMultipleImgs description] 监控多图模式替换
                 * @return {[type]} [description]
                 */
                function watchMultipleImgs() {
                    if (angular.isFunction(multipleImgsWatcher)) {
                        multipleImgsWatcher();
                    }
                    // 如果是多图模式，且多图已经加载完成，则初始化多图div
                    multipleImgsWatcher = scope.$watch('multipleImgs', function(newValue, oldValue) {
                        if (newValue) {
                            showMultiImgs();
                        }
                    });
                }

                /**
                 * [showMultiImgs description] 多图模式下显示多图元素
                 * @return {[type]} [description]
                 */
                function showMultiImgs() {
                    $timeout(function() {
                        for (var i = 0; i < scope.picturesData.length; i++) {
                            // 只在子图片数量大于1的时候可以展开图集
                            if (scope.picturesData[i][scope.childrenName] != undefined && scope.picturesData[i][scope.childrenName].length > 1) {
                                var imgElement = element.find('.simpleImg' + i); // 单图元素
                                imgElement[0].isShowMultiImgs = false;
                                // 给多图元素添加宽度、位置样式
                                var multiImgEle = element.find('.multiImg' + i); // 多图元素
                                // (multiImgEle.parents(".proportion_imgflow").width() - parseInt(multiImgEle.parents(".proportion_imgflow_box").css("margin-right")))
                                multiImgEle.css({
                                    'width': scope.status.containerWidth + 'px', // 瀑布流整体宽度-单图元素右外边距
                                    'left': (-multiImgEle.parents('.proportion_imgflow_box').position().left) + 'px', // 单图元素距离瀑布流左侧的距离
                                    'margin-top': multiImgEle.parents('.proportion_imgflow_box').css('margin-bottom'), // 单图元素的下外边距
                                    'padding-top': multiImgEle.find('.proportion_imgflow_imgsBox').css('margin-bottom'), // 多图元素下每个图片div的下外边距
                                    'padding-left': multiImgEle.find('.proportion_imgflow_imgsBox').css('margin-right'), // 多图元素下每个图片div的右外边距
                                    'padding-right': multiImgEle.find('.proportion_imgflow_imgsBox').css('margin-right') // 多图元素下每个图片div的右外边距
                                });
                                multiImgEle.find('.imgflow_multiImgs').css({ 'width': parseInt(multiImgEle.css('width')) - parseInt(multiImgEle.css('padding-left')) - parseInt(multiImgEle.css('padding-right')) + 'px' }); // 多图元素下的图片瀑布流整体宽度=多图元素的宽度-多图元素的左内边距
                                imgElement.find('img').unbind().bind({
                                    // 鼠标移到图片上显示提示文字
                                    mouseenter: function() {
                                        var $this = $(this);
                                        var $info = $this.parent().find('.unfold_atlas');
                                        var $otherInfo = $this.parents('.proportion_imgflow').find('.unfold_atlas');
                                        // 先清空所有提示文字
                                        $otherInfo.hide();
                                        $info.css({
                                            'width': $this.width() + 'px',
                                            'height': $this.height() + 'px',
                                            'line-height': $this.height() + 'px'
                                        });
                                        $this.parent()[0].isShowMultiImgs === false ? $info.html('点击展开图集') : $info.html('点击收起图集');
                                        $info.show();
                                    }
                                });
                                imgElement.find('.unfold_atlas').unbind().bind({
                                    // 鼠标移开提示文字消失
                                    mouseleave: function() {
                                        var $this = $(this);
                                        $this.hide();
                                    },
                                    // 鼠标点击提示文字显示或者隐藏多图窗口
                                    click: function() {
                                        var $this = $(this);
                                        var $multiImgs = $this.parents('.proportion_imgflow_box').find('.proportion_imgflow_multiImgs');
                                        if ($this.parent()[0].isShowMultiImgs === false) {
                                            var wholeHeight = $this.parents('.proportion_imgflow').height(); // 整个瀑布流的高度
                                            var positionTop = $this.parents('.proportion_imgflow_box').position().top; // 当前图片块到瀑布流顶部的高度
                                            var simpleHeight = $this.parents('.proportion_imgflow_box').height(); // 当前图片块的高度
                                            var multiHeight = $multiImgs.height() + parseInt($multiImgs.find('.proportion_imgflow_imgsBox').css('margin-bottom')) + parseInt($multiImgs.parents('.proportion_imgflow_box').css('margin-bottom')); // 当前图片块的多图模式的高度
                                            if (wholeHeight - positionTop - simpleHeight < multiHeight) {
                                                // 当多图模式的高度超过整个瀑布流的高度，则整个瀑布流的高度自适应
                                                $this.parents('.proportion_imgflow').css({
                                                    'height': (positionTop + simpleHeight + multiHeight) + 'px',
                                                });
                                            } else {
                                                // 否则瀑布流整体高度恢复
                                                $this.parents('.proportion_imgflow').css({
                                                    'height': 'initial',
                                                });
                                            }
                                            // 给多图窗口添加箭头样式
                                            $multiImgs.find('.pack1').css({ 'left': ($this.parents('.proportion_imgflow_box').position().left - 20 + $this.width() / 2 - 10) + 'px' });
                                            $multiImgs.find('.pack2').css({ 'left': ($this.parents('.proportion_imgflow_box').position().left - 20 + $this.width() / 2 - 10 + 2) + 'px' });
                                            // 其他多图窗口全部隐藏
                                            $this.parents('.proportion_imgflow').find('.proportion_imgflow_multiImgs').hide();
                                            for (var j = 0; j < scope.picturesData.length; j++) {
                                                $this.parents('.proportion_imgflow').find('.proportion_imgflow_simpleImg')[j].isShowMultiImgs = false;
                                            }
                                            $multiImgs.show();
                                            $this.parent()[0].isShowMultiImgs = true;
                                        } else {
                                            // 瀑布流整体高度恢复
                                            $this.parents('.proportion_imgflow').css({
                                                'height': 'initial',
                                            });
                                            $multiImgs.hide();
                                            $this.parent()[0].isShowMultiImgs = false;
                                        }
                                    }
                                });
                            }
                        }
                    }, 10);
                }
            }
        };
    }]);
